import apiClient from '../../apiClient';
import { HandleAuthError } from '../universal/Alert';

export const HandleDownload = (bucketName, folder, filename) => {
    var combined_filename = "";
    if (folder != null) {
        combined_filename += folder
    }
    combined_filename += filename
    apiClient.post(
        "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
        {
            "function_to_execute": "Download_Base_64_File_From_Cloud_Storage",
            "bucket_name": bucketName,
            "file_name": combined_filename,
            "download_type": "bytes",
        }
    ).then((res) => {
        var a = document.createElement("a"); //Create <a>
        a.href = "data:image/png;base64," + res.data; //Image Base64 Goes here
        a.download = filename; //File name Here
        a.click(); //Downloaded file
    }).catch(function (error) {
        if (error?.response?.status === 401) {
            HandleAuthError()
        }
        console.log(error)
    });
}